import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Feature,
  OfferType,
  useCapabilities,
  useCapabilitiesFirstOffer,
} from '@app/api';
import { Chip, IconChip } from '@app/core';

interface Props {
  planId?: string;
  feature?: Feature;
  children?: React.ReactNode;
  className?: string;
}

export const LockFeatureChip = ({
  className,
  planId,
  feature,
  children,
}: Props) => {
  const { t } = useTranslation('common');
  const capabilities = useCapabilities(planId);
  const offer = useCapabilitiesFirstOffer(feature);

  if (!capabilities || !feature || capabilities[feature]) {
    if (!children) {
      return null;
    }
    return <>{children}</>;
  }

  if (!offer) {
    return (
      <Chip className={className} color="purple">
        {t('comingSoon')}
      </Chip>
    );
  }

  return (
    <IconChip
      className={className}
      color={offer.color}
      label={offer.shortName}
      icon={
        offer.type === OfferType.SUBSCRIPTION
          ? 'ri-sparkling-2-line'
          : undefined
      }
    />
  );
};
